
import { defineComponent, ref, computed } from "vue";
import { getIllustrationsPath } from "@/core/helpers/assets";
import { RegisteredCoursesRequest } from "@/core/endpoints/requests/earlyregisteredCourses_request";
import { RegisteredCoursesResponse } from "@/core/endpoints/responses/registeredCourses_response";
import { getCurrentInstance } from "vue";
import { UserInfoRequest } from "@/core/endpoints/requests/userInfo_request";
import { UserInfoResponse } from "@/core/endpoints/responses/userInfo_response";
import Condition from "yup/lib/Condition";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
  name: "widget-1",
  props: {
    widgetClasses: String,
    Course: String,
  },
  setup(props) {
    const { t, te } = useI18n();
    const store = useStore();
    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };
    let registeredCoursesRequest = new RegisteredCoursesRequest();
    const registerToCoursesRes = ref<any>();
    const registerToArray = ref<any>();
    const searchQueryOutput = ref<any>();

    let userInfoRequest = new UserInfoRequest();
    const searchQuery = ref("");
    const app = getCurrentInstance();
    // const errorMessage = computed(() => store.getters["errorModule/getErrorMessage"]);
    const errorMessage = computed(() => store.getters.getErrorMessage);
    //console.log(errorMessage);
    //console.log(errorMessage);

    const registerToCoursesResChange = () => {
      // registerToArray.value = [];
      // registerToArray.value = [];
      //console.log(registerToCoursesRes.value);
      //console.log(registerToArray.value);

      const searchQueryValue = searchQuery.value.toLowerCase();
      //console.log(searchQueryValue);

      if (searchQueryValue) {
        searchQueryOutput.value =
          registerToCoursesRes.value.coursesToRegister.filter((course) =>
            course.coursE_CODE.toLowerCase().includes(searchQueryValue)
          );

        // registerToArray.value = searchQueryOutput; // set registerToArray directly to searchQueryOutput
        //console.log(searchQueryOutput);
        //console.log(registerToArray.value);
      } else {
        registerToArray.value;
      }
    };

    const BeginOfferedCourses = () => {
      if (localStorage.getItem("Course")) {
        const parsedCourse = JSON.parse(localStorage.getItem("Course") || "{}");
        const undroppCourse: any = {
          coursE_CODE: parsedCourse.courseCode,
          coursE_DESCR: parsedCourse.courseDescr,
          crediT_HOURS: parsedCourse.creditHours,
          eD_COURSE_ID: parsedCourse.edCourseId,
          hdR_DESCR: "",
          edStudCourseRegId: parsedCourse.edStudCourseRegId,
          scscheduleDtlId: parsedCourse.scScheduleDtlId,
          isReplace: parsedCourse.isReplace,
        };
        if (parsedCourse.isReplace) {
          //replace
          undroppCourse.hdR_DESCR = "Replace";

          const user = localStorage.getItem("userInfo") || "";
          const res = JSON.parse(user);
          let userinfo: any = {};
          userinfo = res;
          registeredCoursesRequest.EdStudSemesterId =
            userinfo.earlyRegData.early_EdstudsemesterId;
          registeredCoursesRequest.EdAcadYearId =
            userinfo.earlyRegData.early_YearId;
          registeredCoursesRequest.EdStudId = userinfo.edStudId;
          registeredCoursesRequest.AsFacultyInfoID = userinfo.asFacultyInfoId;
          registeredCoursesRequest.AsCodeDegreeID = userinfo.asCodeDegreeId;
          registeredCoursesRequest.EdCodeSemesterID =
            userinfo.earlyRegData.early_EdCodeSemesterId;
          registeredCoursesRequest.invokeGetListOfCourseToBeRegistered(
            app,
            (me: any, registeredCoursesResponse: any) => {
              // debugger;
              if (registeredCoursesResponse) {
                const ObjArrayInjection =
                  registeredCoursesResponse.coursesToRegister;
                ObjArrayInjection.forEach(function (item) {
                  item.edStudCourseRegId = parsedCourse.edStudCourseRegId;
                  item.scScheduleDtlId = parsedCourse.scScheduleDtlId;
                  item.isReplace = true;
                });
                registerToCoursesRes.value = ObjArrayInjection;
                registerToArray.value = ObjArrayInjection;

                //registerToCoursesRes.value.unshift(undroppCourse);
                registerToArray.value.unshift(undroppCourse);
                localStorage.removeItem("Course");
                registerToCoursesResChange();
              }
            }
          );
        } else {
          //UNdrop
          // eslint-disable-next-line vue/no-setup-props-destructure
          // registerToCoursesRes.value=props.Course
          undroppCourse.hdR_DESCR = "Undrop";

          registerToCoursesRes.value = [];
          registerToCoursesRes.value.push(undroppCourse);
          registerToArray.value = [];
          registerToArray.value.push(undroppCourse);
          localStorage.removeItem("Course");
          registerToCoursesResChange();
        }
      } else {
        const user = localStorage.getItem("userInfo") || "";
        const res = JSON.parse(user);
        let userinfo: any = {};
        userinfo = res;
        registeredCoursesRequest.EdStudSemesterId =
          userinfo.earlyRegData.early_EdstudsemesterId;
        registeredCoursesRequest.EdAcadYearId =
          userinfo.earlyRegData.early_YearId;
        registeredCoursesRequest.EdStudId = userinfo.edStudId;
        registeredCoursesRequest.AsFacultyInfoID = userinfo.asFacultyInfoId;
        registeredCoursesRequest.AsCodeDegreeID = userinfo.asCodeDegreeId;
        registeredCoursesRequest.EdCodeSemesterID =
          userinfo.earlyRegData.early_EdCodeSemesterId;

        registeredCoursesRequest.invokeGetListOfCourseToBeRegistered(
          app,
          (me: any, registeredCoursesResponse: any) => {
            if (registeredCoursesResponse) {
              registerToCoursesRes.value = registeredCoursesResponse;
              registerToArray.value =
                registeredCoursesResponse.coursesToRegister;
              localStorage.removeItem("Course");
              registerToCoursesResChange();
            }
          }
        );
      }
    };

    BeginOfferedCourses();

    return {
      getIllustrationsPath,
      registerToCoursesRes,
      searchQuery,
      registerToCoursesResChange,
      BeginOfferedCourses,
      registerToArray,
      translate,
      searchQueryOutput,
      errorMessage,
    };
  },
});
